module.exports = __webpack_public_path__ + "static/outsourcing-b7c15bb98c0b6e13e7a519e4a7a7a828.svg";